<template>
    <nav class="nav nav-pills cursus-nav">
        <a class="nav-link" :class="{ 'active': value.formations !== '0' && value.formations !== '1' }" href="#" @click.prevent="handleChanged({ })">
            Tout
        </a>
        <a class="nav-link" :class="{ 'active': value.formations === '1' }" href="#" @click.prevent="handleChanged({ formations: '1' })">
            Formations
        </a>
        <a class="nav-link" :class="{ 'active': value.formations === '0' }" href="#" @click.prevent="handleChanged({ formations: '0' })">
            Rencontres / Parcours
        </a>
    </nav>
</template>

<script>
import Icon from "../ui/Icon.vue";

export default {
        components: { Icon },
        props: {
            value: Object,
        },
        methods: {
            handleChanged({ formations=undefined }) {
                this.$emit('input', {
                    ...this.value,
                    formations,
                });
            },
        },
    }
</script>



